import React from 'react';

export const CenturionNetworkVideo = () => {
  return <div>CenturionNetworkVideo</div>;
};
